__turbopack_context__.v({
  "className": "inter_d10ec56a-module__PZw9aq__className",
  "variable": "inter_d10ec56a-module__PZw9aq__variable",
});
